export default "__VITE_ASSET__e363d6e7__"